import { TileIndex } from "../../types";

export const TWO_BEES: TileIndex[][] = [

  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 15, 0, 28, 0, 0, 1, 16, 16, 3, 0, 0, 0, 1, 12, 0, 0, 0, 12, 1],
  [1, 27, 0, 0, 0, 0, 1, 16, 16, 0, 0, 24, 0, 1, 0, 18, 0, 1, 1, 1],
  [1, 0, 0, 0, 0, 0, 1, 16, 16, 0, 0, 0, 0, 1, 0, 25, 0, 0, 1, 1],
  [1, 1, 1, 1, 9, 1, 1, 16, 16, 16, 16, 20, 16, 1, 0, 0, 0, 0, 0, 1],
  [1, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 20, 16, 1, 1, 26, 1, 1, 1, 1],
  [1, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 20, 16, 16, 16, 21, 3, 0, 2, 1],
  [1, 16, 16, 16, 16, 16, 16, 16, 16, 17, 0, 20, 22, 22, 22, 22, 0, 2, 3, 1],
  [1, 0, 0, 0, 2, 16, 16, 16, 16, 0, 0, 0, 16, 0, 16, 16, 3, 0, 2, 1],
  [1, 0, 0, 0, 2, 16, 16, 16, 16, 16, 16, 16, 16, 0, 16, 16, 0, 2, 3, 1],
  [1, 0, 0, 0, 0, 2, 16, 16, 16, 16, 16, 16, 16, 0, 16, 16, 3, 0, 2, 1],
  [1, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 5, 16, 16, 0, 2, 3, 1],
  [1, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 0, 16, 16, 3, 0, 0, 1],
  [1, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 0, 16, 16, 0, 0, 3, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
]
